import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
export const AuthContext = React.createContext(undefined);
/**
 * Authentication context provider. This must be rendered above any other components
 * that need access to authentication context.
 * @param auth - auth instance that conforms to IAuth interface
 */
export const AuthProvider = ({ children, auth }) => {
    const Provider = useMemo(() => {
        return auth.getProvider(children);
    }, [auth, children]);
    return _jsx(AuthContext.Provider, { value: auth, children: Provider });
};
//# sourceMappingURL=AuthContext.js.map